import business1 from '../assets/images/business1.png';
import business2 from '../assets/images/business2.png';
import business3 from '../assets/images/business3.png';
import business4 from '../assets/images/business4.png';
import business5 from '../assets/images/business5.png';
import business6 from '../assets/images/business6.png';
import business7 from '../assets/images/business7.png';
import business8 from '../assets/images/business8.png';
import business9 from '../assets/images/business9.png';
import business10 from '../assets/images/business10.png';
import business11 from '../assets/images/business11.png';
import business12 from '../assets/images/business12.png';
import business13 from '../assets/images/business13.png';
import business14 from '../assets/images/business14.png';

export default [
  {
    sn: '01',
    img: business1
  },
  {
    sn: '02',
    img: business2
  },
  {
    sn: '03',
    img: business3
  },
  {
    sn: '04',
    img: business4
  },
  {
    sn: '05',
    img: business5
  },
  {
    sn: '06',
    img: business6
  },
  {
    sn: '07',
    img: business7
  },
  {
    sn: '08',
    img: business8
  },
  {
    sn: '09',
    img: business9
  },
  {
    sn: '10',
    img: business10
  },
  {
    sn: '11',
    img: business11
  },
  {
    sn: '12',
    img: business12
  },
  {
    sn: '13',
    img: business13
  },
  {
    sn: '14',
    img: business14
  }
];
